export interface GoalUpdateRequestDto {
  status?: string | null;
  activeUntil?: string | null;
  goalAmount?: number | null;
  excessAllowed?: boolean | null;
}
